import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import apiClient from '../api/client';
import './AdminMenu.css';

/**
 * Menu Mobile para Admin - Versão 2
 * Menu rápido com todas as opções de gestão de rodada
 */

const AdminMenu = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [rodadaAberta, setRodadaAberta] = useState(null);
  const [loading, setLoading] = useState(true);

  const carregarRodadaAberta = useCallback(async () => {
    try {
      const response = await apiClient.get('/rodadas');
      const rodadas = Array.isArray(response.data) ? response.data : [];
      const aberta = rodadas.find(r => r.status === 'aberta');
      setRodadaAberta(aberta || null);
    } catch (error) {
      console.error('Erro ao carregar rodada aberta:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }
    carregarRodadaAberta();
  }, [isAdmin, navigate, carregarRodadaAberta]);

  if (!isAdmin) {
    return null;
  }

  if (loading) {
    return <div className="container">Carregando...</div>;
  }

  return (
    <div className="admin-menu-container">
      <div className="admin-menu-header">
        <h1>🎮 Menu Admin </h1>
        {rodadaAberta && (
          <div className="rodada-aberta-info">
            <p><strong>Rodada Aberta:</strong> {new Date(rodadaAberta.data).toLocaleDateString('pt-BR')}</p>
          </div>
        )}
      </div>

      {/* Menu de Administração Geral */}
      <div className="admin-menu-section">
        <h2>Administração Geral</h2>
        <div className="admin-menu-grid">
          {/* Cadastro de Jogadores */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/jogadores')}
          >
            <div className="menu-icon">➕</div>
            <div className="menu-title">Cadastro de Jogadores</div>
            <div className="menu-desc">Gerenciar jogadores</div>
          </button>

          {/* Trocas Admin Nocautes x Prêmios */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/trocas')}
          >
            <div className="menu-icon">🔄</div>
            <div className="menu-title">Trocas Admin</div>
            <div className="menu-desc">Trocar em nome dos jogadores</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/admin/financeiro-nerdz')}>
            <div className="menu-icon">💰</div>
            <div className="menu-title">Financeiro Nerdz</div>
            <div className="menu-desc">Saldo Caixinha Poker</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/admin/temas')}>
            <div className="menu-icon">🎨</div>
            <div className="menu-title">Configurar Temas</div>
            <div className="menu-desc">Escolher tema do site</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/admin/configuracao-calculo')}>
            <div className="menu-icon">⚙️</div>
            <div className="menu-title">Lógica de Cálculo</div>
            <div className="menu-desc">Configurar regras de cálculo</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/admin/configuracao-premios-pontos')}>
            <div className="menu-icon">🏆</div>
            <div className="menu-title">Prêmios e Pontos</div>
            <div className="menu-desc">Configurar pontuação e prêmios</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/admin/configurar-whatsapp')}>
            <div className="menu-icon">📱</div>
            <div className="menu-title">Configurar WhatsApp</div>
            <div className="menu-desc">Conectar e testar WhatsApp</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/admin/aprovar-imagens-nocautes')}>
            <div className="menu-icon">🎨</div>
            <div className="menu-title">Aprovar Imagens</div>
            <div className="menu-desc">Aprovar imagens de nocaute</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/admin/imagens-aleatorias')}>
            <div className="menu-icon">🎲</div>
            <div className="menu-title">Imagens Aleatórias</div>
            <div className="menu-desc">Gerenciar banco de imagens</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/admin/auditoria-nocautes')}>
            <div className="menu-icon">⚙️🥊</div>
            <div className="menu-title">Auditoria de Nocautes</div>
            <div className="menu-desc">Consultar registros por rodada</div>
          </button>
        </div>
      </div>

      {/* Menu de Administração Rodada */}
      <div className="admin-menu-section">
        <h2>Administração Rodada</h2>
        <div className="admin-menu-grid">
          {/* Abrir Rodada */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/rodadas')}
          >
            <div className="menu-icon">📅</div>
            <div className="menu-title">Abrir Rodada</div>
            <div className="menu-desc">Cadastrar data da rodada</div>
          </button>

          {/* Incluir Jogadores */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/incluir-jogadores')}
            disabled={!rodadaAberta}
          >
            <div className="menu-icon">👥</div>
            <div className="menu-title">Incluir Jogadores</div>
            <div className="menu-desc">Confirmar jogadores na rodada</div>
          </button>

          {/* Incluir Entrada Antecipada */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/entrada-antecipada')}
            disabled={!rodadaAberta}
          >
            <div className="menu-icon">💰</div>
            <div className="menu-title">Entrada Antecipada</div>
            <div className="menu-desc">R$ 40,00 pago antecipadamente</div>
          </button>

          {/* Incluir Nocaute */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/nocaute')}
            disabled={!rodadaAberta}
          >
            <div className="menu-icon">🥊</div>
            <div className="menu-title">Incluir Nocaute</div>
            <div className="menu-desc">Registrar nocaute</div>
          </button>

          {/* Incluir Rebuy */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/rebuy')}
            disabled={!rodadaAberta}
          >
            <div className="menu-icon">🔄</div>
            <div className="menu-title">Incluir Rebuy</div>
            <div className="menu-desc">Simples ou duplo</div>
          </button>

          {/* Incluir Add-on */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/addon')}
            disabled={!rodadaAberta}
          >
            <div className="menu-icon">⚡</div>
            <div className="menu-title">Incluir Add-on</div>
            <div className="menu-desc">Adicionar add-on</div>
          </button>

          {/* Incluir Jackpot */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/jackpot')}
            disabled={!rodadaAberta}
          >
            <div className="menu-icon">🎰</div>
            <div className="menu-title">Incluir Jackpot</div>
            <div className="menu-desc">Marcar ganhador</div>
          </button>

          {/* Incluir Janta */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/janta')}
            disabled={!rodadaAberta}
          >
            <div className="menu-icon">🍽️</div>
            <div className="menu-title">Incluir Janta</div>
            <div className="menu-desc">Valor e participantes</div>
          </button>

          {/* Lançar Posição Final */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/posicao-final')}
            disabled={!rodadaAberta}
          >
            <div className="menu-icon">🏆</div>
            <div className="menu-title">Lançar Posição Final</div>
            <div className="menu-desc">Classificar jogadores (1 a N)</div>
          </button>

          {/* Editar Posições Finais */}
          {rodadaAberta && (
            <button
              className="admin-menu-card"
              onClick={() => navigate(`/admin/editar-posicoes/${rodadaAberta.id}`)}
            >
              <div className="menu-icon">✏️</div>
              <div className="menu-title">Editar Posições</div>
              <div className="menu-desc">Ajustar posições já lançadas</div>
            </button>
          )}

          {/* Recalcular Valores */}
          {rodadaAberta && (
            <button
              className="admin-menu-card"
              onClick={() => navigate(`/admin/recalcular-valores/${rodadaAberta.id}`)}
            >
              <div className="menu-icon">🔄</div>
              <div className="menu-title">Recalcular Valores</div>
              <div className="menu-desc">Ajustar valores financeiros</div>
            </button>
          )}

          {/* Ajustar Rodada */}
          {rodadaAberta && (
            <button
              className="admin-menu-card"
              onClick={() => navigate(`/admin/ajustar-rodada/${rodadaAberta.id}`)}
            >
              <div className="menu-icon">⚙️</div>
              <div className="menu-title">Ajustar Rodada</div>
              <div className="menu-desc">Editar todos os lançamentos</div>
            </button>
          )}

          {/* Ajustar Nocautes */}
          {rodadaAberta && (
            <button
              className="admin-menu-card"
              onClick={() => navigate(`/admin/ajustar-nocautes/${rodadaAberta.id}`)}
            >
              <div className="menu-icon">🥊</div>
              <div className="menu-title">Ajustar Nocautes</div>
              <div className="menu-desc">Editar ou deletar nocautes</div>
            </button>
          )}
            
          {/* Gastos por Rodada */}
            <button className="admin-menu-card" onClick={() => navigate('/admin/gastos')}>
            <div className="menu-icon">💸</div>
            <div className="menu-title">Gastos por Rodada</div>
            <div className="menu-desc">Gerenciar gastos</div>
            </button>

          {/* Conferência da Rodada */}
          {rodadaAberta && (
            <button
              className="admin-menu-card"
              onClick={() => navigate(`/admin/conferencia-rodada/${rodadaAberta.id}`)}
            >
              <div className="menu-icon">🔍</div>
              <div className="menu-title">Conferência da Rodada</div>
              <div className="menu-desc">Saldo devedor, posições e prêmios</div>
            </button>
          )}

          {/* Fechar Rodada */}
          {rodadaAberta && (
            <button
              className="admin-menu-card fechar-rodada"
              onClick={() => navigate(`/rodadas/${rodadaAberta.id}/fechar`)}
            >
              <div className="menu-icon">✅</div>
              <div className="menu-title">Fechar Rodada</div>
              <div className="menu-desc">Finalizar rodada</div>
            </button>
          )}
        </div>
      </div>

      {/* Menu de Lançamentos BAR */}
      <div className="admin-menu-section">
        <h2>Lançamentos Bonitinho - BAR</h2>
        <div className="admin-menu-grid">
          {/* Consumo BAR */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/consumo-bar')}
            disabled={!rodadaAberta}
          >
            <div className="menu-icon">🍺</div>
            <div className="menu-title">Consumo BAR</div>
            <div className="menu-desc">Lançar consumos</div>
          </button>

          {/* Produtos BAR */}
          <button
            className="admin-menu-card"
            onClick={() => navigate('/admin/produtos-bar')}
          >
            <div className="menu-icon">📦</div>
            <div className="menu-title">Produtos BAR</div>
            <div className="menu-desc">Gerenciar produtos</div>
          </button>
        </div>
      </div>

      {/* Menus de Consulta */}
      <div className="admin-menu-section">
        <h2>Menu Jogador</h2>
        <div className="admin-menu-grid">
          <button className="admin-menu-card" onClick={() => navigate('/ranking')}>
            <div className="menu-icon">🏆</div>
            <div className="menu-title">Ranking</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/nocautes')}>
            <div className="menu-icon">🥊</div>
            <div className="menu-title">Nocautes</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/financeiro')}>
            <div className="menu-icon">💰</div>
            <div className="menu-title">Financeiro</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/admin/consulta-consumo-bar')}>
            <div className="menu-icon">🍺</div>
            <div className="menu-title">Consulta BAR</div>
            <div className="menu-desc">Ver saldos e marcar pagos</div>
          </button>

          <button className="admin-menu-card" onClick={() => navigate('/minhas-imagens-nocautes')}>
            <div className="menu-icon">🎨</div>
            <div className="menu-title">Minhas Imagens Nocaute</div>
            <div className="menu-desc">Gerenciar minhas imagens</div>
          </button>
        </div>
      </div>

      <footer className="app-footer">
        <div className="footer-content">
          <p className="footer-signature">
            Produzido by <strong>Chicão</strong>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AdminMenu;
